module.exports = __webpack_public_path__ + "files/e953e40770b3c55a85359c3140b1c367.png";